import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const GetDoctorTreatmentMedicineOpenDateDocument = `
    query GetDoctorTreatmentMedicineOpenDate($doctorId: ID!, $treatmentMedicineId: ID!) {
  getDoctorTreatmentMedicineOpenDate(
    doctorId: $doctorId
    treatmentMedicineId: $treatmentMedicineId
  ) {
    date
  }
}
    `;
export const useGetDoctorTreatmentMedicineOpenDateQuery = <
      TData = Types.GetDoctorTreatmentMedicineOpenDateQuery,
      TError = Types.GraphqlError
    >(
      variables: Types.GetDoctorTreatmentMedicineOpenDateQueryVariables,
      options?: UseQueryOptions<Types.GetDoctorTreatmentMedicineOpenDateQuery, TError, TData>,
    ) =>
    useQuery<Types.GetDoctorTreatmentMedicineOpenDateQuery, TError, TData>(
      ['GetDoctorTreatmentMedicineOpenDate', variables],
      gqlFetcher<Types.GetDoctorTreatmentMedicineOpenDateQuery, Types.GetDoctorTreatmentMedicineOpenDateQueryVariables>(GetDoctorTreatmentMedicineOpenDateDocument, 'GetDoctorTreatmentMedicineOpenDate', variables),
      options
    );

useGetDoctorTreatmentMedicineOpenDateQuery.getKey = (variables: Types.GetDoctorTreatmentMedicineOpenDateQueryVariables) => ['GetDoctorTreatmentMedicineOpenDate', variables];
;

useGetDoctorTreatmentMedicineOpenDateQuery.fetcher = (variables: Types.GetDoctorTreatmentMedicineOpenDateQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.GetDoctorTreatmentMedicineOpenDateQuery, Types.GetDoctorTreatmentMedicineOpenDateQueryVariables>(GetDoctorTreatmentMedicineOpenDateDocument, 'GetDoctorTreatmentMedicineOpenDate', variables, options);
export const DiagnosesByUserV2Document = `
    query DiagnosesByUserV2($paginationCriteria: PaginationCriteriaInput!) {
  diagnosesByUserV2(paginationCriteria: $paginationCriteria) {
    diagnosis {
      diagnosisForm {
        id
        symptom
      }
    }
  }
}
    `;
export const useDiagnosesByUserV2Query = <
      TData = Types.DiagnosesByUserV2Query,
      TError = Types.GraphqlError
    >(
      variables: Types.DiagnosesByUserV2QueryVariables,
      options?: UseQueryOptions<Types.DiagnosesByUserV2Query, TError, TData>,
    ) =>
    useQuery<Types.DiagnosesByUserV2Query, TError, TData>(
      ['DiagnosesByUserV2', variables],
      gqlFetcher<Types.DiagnosesByUserV2Query, Types.DiagnosesByUserV2QueryVariables>(DiagnosesByUserV2Document, 'DiagnosesByUserV2', variables),
      options
    );

useDiagnosesByUserV2Query.getKey = (variables: Types.DiagnosesByUserV2QueryVariables) => ['DiagnosesByUserV2', variables];
;

useDiagnosesByUserV2Query.fetcher = (variables: Types.DiagnosesByUserV2QueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.DiagnosesByUserV2Query, Types.DiagnosesByUserV2QueryVariables>(DiagnosesByUserV2Document, 'DiagnosesByUserV2', variables, options);